class BackboneService {
    dispatchToCustomControls(method: string, ...args: any[]) {
        const controls = [...document.querySelectorAll("*")]
            .filter(el => el.tagName.toLowerCase().startsWith("hat-"));

        controls.forEach(ctrl => {
            const el = ctrl as Record<string, any>;
            if (typeof el[method] === "function") {
                el[method](...args);
            }
        });
    }

    navigateTo(path: string | null) {
        history.pushState({}, "", path ?? '/');
        this.dispatchToCustomControls("onNavigate", path);
    }
}

export const backboneService = new BackboneService();